import type { BlockSectionProps } from '@/lib/section-background';

export type PageTitleElement = 'breadcrumb' | 'title' | 'subtitle';
export const DEFAULT_ELEMENT_ORDER: PageTitleElement[] = ['breadcrumb', 'title', 'subtitle'];

export interface PageTitleProps extends BlockSectionProps {
  title: string | null;
  showBreadcrumb: boolean;
  showSubtitle: boolean;
  subtitle: string | null;
  elementOrder: PageTitleElement[] | null;
}
